import React, { useRef, useState } from 'react';
import { Camera, Loader2 } from 'lucide-react';
import { API, api, resizeImage } from '../../utils/deliveryApi';

// Take photos with the device camera (or pick files), downscale them and attach them to the protocol step/item.
const PhotoCapture = ({ protocolId, step, itemKey = null, photos, onChange, disabled, compact = false, hideButton = false, label = 'Vyfotit' }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const upload = async (files) => {
    setBusy(true); setError('');
    try {
      for (const file of files) {
        const blob = await resizeImage(file);
        const form = new FormData();
        form.append('step', String(step));
        if (itemKey) form.append('item_key', itemKey);
        form.append('photo', blob, 'foto.jpg');
        await api(`/${protocolId}/photos`, { method: 'POST', form });
      }
      await onChange();
    } catch (err) {
      setError(`Fotku se nepodařilo nahrát: ${err.message}`);
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const remove = async (photo) => {
    try { await api(`/${protocolId}/photos/${photo.id}`, { method: 'DELETE' }); await onChange(); } catch (err) { setError(err.message); }
  };

  return (
    <div>
      {!disabled && !hideButton && (
        <>
          <input ref={inputRef} type="file" accept="image/*" capture="environment" multiple hidden
            onChange={(e) => e.target.files?.length && upload([...e.target.files])} />
          <button type="button" className="dlv-iconbtn" onClick={() => inputRef.current?.click()} disabled={busy} aria-label={label}>
            {busy ? <Loader2 size={16} className="dlv-spin" /> : <Camera size={16} />}
            {!compact && (busy ? 'Nahrávám…' : label)}
            {compact && photos.length > 0 && <span>{photos.length}</span>}
          </button>
        </>
      )}
      {photos.length > 0 && !compact && (
        <div className="dlv-photos">
          {photos.map((p) => (
            <div key={p.id} className="dlv-photo">
              <a href={`${API}/${protocolId}/photos/${p.id}`} target="_blank" rel="noreferrer"><img src={`${API}/${protocolId}/photos/${p.id}`} alt="Fotodokumentace" loading="lazy" /></a>
              {!disabled && <button type="button" onClick={() => remove(p)} aria-label="Smazat fotku">×</button>}
            </div>
          ))}
        </div>
      )}
      {error && <p role="alert" style={{ color: '#b71c1c', fontSize: 13, margin: '6px 0 0' }}>{error}</p>}
    </div>
  );
};

export default PhotoCapture;
